import script from "./xuexiaowangpan.vue?vue&type=script&setup=true&lang=js"
export * from "./xuexiaowangpan.vue?vue&type=script&setup=true&lang=js"

import "./xuexiaowangpan.vue?vue&type=style&index=0&id=c16733b6&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c16733b6"]])

export default __exports__